import TextRecognition from 'react-native-text-recognition';
import * as FileSystem from 'expo-file-system';

export type OcrOptions = {
  language?: 'latin' | 'chinese' | 'devanagari' | 'japanese' | 'korean';
  from?: string;
  to?: string;
};

export type OcrResult = {
  text: string;
  blocks?: { text: string }[];
};

export class OcrService {
  static async recognizeFromBase64(base64: string | undefined | null, _options?: OcrOptions): Promise<OcrResult> {
    if (!base64) return { text: '' };
    const tmpPath = `${FileSystem.cacheDirectory}ocr_input.png`;
    try {
      await FileSystem.writeAsStringAsync(tmpPath, base64, { encoding: FileSystem.EncodingType.Base64 });
      return await this.recognizeFromImage(tmpPath);
    } catch {
      return { text: '' };
    }
  }

  static async recognizeFromImage(uri: string, _options?: OcrOptions): Promise<OcrResult> {
    try {
      // iOS uses Apple Vision (works on arm64 simulator); Android uses MLKit
      const lines = await TextRecognition.recognize(uri);
      const text = Array.isArray(lines) ? lines.join('\n') : (lines as any)?.toString?.() ?? '';
      return { text, blocks: Array.isArray(lines) ? lines.map(t => ({ text: t })) : undefined };
    } catch {
      return { text: '' };
    }
  }
}

export default OcrService;